<template>
  <el-popover :class="containerClass" trigger="click" @show="handleGiveBackPopoverShow">
    <div>
      <div>
        <div>
          <label class="el-form-item__label">Sanción para el taxista</label>
        </div>
        <el-radio-group v-model="sanction.duration" size="mini">
          <el-radio-button
            v-for="sanction in sanctions"
            :key="sanction.value"
            :label="sanction.label"
          ></el-radio-button>
        </el-radio-group>
      </div>
      <div class="mt-3 text-right">
        <div class="giveback-buttons">
          <el-input
            v-if="sanctionValue === 'custom'"
            v-model="sanction.custom"
            class="mr-3 mb-3"
            placeholder="Tiempo de sanción en minutos"
            size="mini"
          />
          <el-button class="ml-auto" size="mini" type="primary" @click="handleAcceptGiveBack(1)">
            Aceptar devolución
          </el-button>
          <el-button
            v-if="!disabledAcceptAndRelaunchGiveBackButton"
            size="mini"
            type="primary"
            @click="handleAcceptGiveBack(2)"
          >
            Aceptar devolución y relanzar
          </el-button>
        </div>
      </div>
    </div>
    <template slot="reference">
      <slot name="default">
        <el-button size="mini" type="primary"> Aceptar devolución</el-button>
      </slot>
    </template>
  </el-popover>
</template>

<script>
import { SANCTIONS } from "@/utils/constants";
import moment from "@/utils/moment";
import { mapGetters } from "vuex";

export default {
  name: "AcceptGiveBackButton",
  props: {
    disabledAcceptAndRelaunchGiveBackButton: Boolean,
    notification: Object,
    extraClasses: String,
    onClose: Function,
    store: Object,
    containerClass: {
      type: String,
      default: "mr-2",
    },
  },
  data() {
    return {
      sanctions: SANCTIONS,
      sanction: {
        duration: "Sin sanción",
        custom: null,
        taxi: null,
      },
    };
  },
  computed: {
    ...mapGetters("app", ["taxis"]),
    sanctionValue() {
      return SANCTIONS.find((s) => s.label === this.sanction.duration)?.value || 0;
    },
  },
  methods: {
    async handleAcceptGiveBack(answer) {
      const sanction =
        this.sanctionValue === "custom"
          ? parseInt(this.sanction.custom)
          : parseInt(this.sanctionValue);

      const params = {
        id: this.notification.inserted,
        wgId: this.notification.idWg,
      };

      await this.callAnswerNotification({ answer }, params);
      if (sanction) {
        const taxi = {
          ...this.taxis.find((t) => t.id === this.notification.idTaxi),
        };
        delete taxi.drivers;
        const now = Date.now();
        const end = moment()(now).add(sanction, "minutes").toDate().getTime();
        const sanctionData = {
          appliedSanction: 2,
          sanctionFrom: now,
          sanctionTo: end,
          sanctionText: "",
        };
        const updatedTaxi = Object.assign({}, taxi, { sanctionData });
        const payload = {
          data: updatedTaxi,
          params: {
            wgId: taxi.idWorkgroup,
            centralId: taxi.idCentral,
            taxiId: taxi.id,
          },
        };
        this.store.dispatch("clientTaxis/updateTaxi", payload);
      }
    },

    async handleGiveBackPopoverShow() {
      if (!this.sanction.taxi) {
        const { idTaxi, idWg } = this.notification;
        this.sanction.taxi = await this.store.dispatch("clientTaxis/getTaxiById", {
          hasToReturnData: true,
          params: {
            wgId: idWg,
            taxiId: idTaxi,
          },
        });
      }
    },

    handleClose() {
      if (this.onClose) {
        this.onClose();
      }
    },

    async callAnswerNotification(data, params) {
      const payload = {
        data: JSON.stringify(data),
        params,
      };
      await this.store.dispatch("clientNotifications/answerNotification", payload);
      this.handleClose();
    },
  },
};
</script>
